<template>
  <button
    :class="buttonIconRounded.class"
    :data-tooltip-text="buttonIconRounded.tooltip"
    :type="buttonIconRounded.type"
    @click="click($event)"
  >
    <i
      v-if="showLoading"
      key="loadingIcon"
      class="fas fa-spinner fa-spin"
    >
    </i>
    <i
      v-else
      key="actionIcon"
      :class="buttonIconRounded.icon"
    >
    </i>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonIconRounded',

  props: {
    buttonIconRounded: Object,
    element: {
      type: [Array, Number, Object, String],
      default: null
    },
    particularComponent: {
      type: String,
      default: ''
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    click (event) {
      let component = this.buttonIconRounded.component.length
        ? this.buttonIconRounded.component
        : this.particularComponent.length
          ? this.particularComponent
          : ''

      if (component.length) {
        event.stopPropagation()
        this.$emit(this.buttonIconRounded.method, component, this.element)
      } else {
        this.$emit(this.buttonIconRounded.method, this.element)
      }
    }
  }
}
</script>
